<template>
  <div class="app-main__inner col-sm-9 col-12 m-auto">
    <TituloComponente icono-titulo="fas fa-plus" texto-titulo="Nueva Institución" />
    <div class="tab-content">
      <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
        <div class="row">
          <div class="col-12">
            <div class="main-card mb-3 card">
              <div class="card-body">
                <h5 class="card-title">Datos:</h5>
                <form @submit.prevent="guardarInstitucion()" class="row">
                  <float-label label="Razon Social:" clase="col-sm-6 col-12">
                    <input
                      id="razonSocial"
                      v-model="institucion.razon_social"
                      placeholder="Ingresar Razon Social..."
                      type="text"
                      class="form-control"
                      :class="(enviado && !$v.institucion.razon_social.required) ? 'is-invalid' : ''"
                    />
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.razon_social.required"
                      >Debe ingresar una Razon Social</div>
                    </template>
                  </float-label>
                  <float-label label="Cuit:" clase="col-sm-6 col-12">
                    <input
                      id="cuit"
                      v-model="institucion.cuit"
                      placeholder="Ingresar CUIT..."
                      type="text"
                      inputmode="numeric"
                      class="form-control"
                      :class="(enviado && !$v.institucion.cuit.required) ? 'is-invalid' : ''"
                    />
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.cuit.required"
                      >Debe ingresar un CUIT</div>
                      <div
                        class="invalid-feedback"
                        v-if="institucion.cuit && !$v.institucion.cuit.numeric"
                      >Sólo se aceptan números</div>
                    </template>
                  </float-label>
                  <float-label label="Provincia:" clase="col-sm-4 col-12">
                    <select
                      name="provincia"
                      id="provincia"
                      class="form-control"
                      v-model="provinciaSelected"
                      @change="obtenerMunicipios"
                      :class="(enviado && !$v.institucion.provincia.required) ? 'is-invalid' : ''"
                    >
                      <option value="null">Seleccione una Provincia</option>
                      <option
                        :value="provincia"
                        v-for="provincia in provincias"
                        :key="provincia.nombre"
                      >{{provincia.nombre}}</option>
                    </select>
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.provincia.required"
                      >Debe ingresar una Provincia</div>
                    </template>
                  </float-label>
                  <float-label label="Localidad:" clase="col-sm-4 col-12">
                    <select
                      name="localidad"
                      id="localidad"
                      class="form-control"
                      v-model="institucion.localidad"
                      :class="(enviado && !$v.institucion.localidad.required) ? 'is-invalid' : ''"
                    >
                      <option value="null">Seleccione una Localidad</option>
                      <option
                        :value="municipio.nombre"
                        v-for="municipio in municipios"
                        :key="municipio.nombre"
                      >{{municipio.nombre}}</option>
                    </select>
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.localidad.required"
                      >Debe ingresar una Localidad</div>
                    </template>
                  </float-label>
                  <float-label label="Domicilio:" clase="col-sm-4 col-12">
                    <input
                      id="domicilio"
                      v-model="institucion.domicilio"
                      placeholder="Ingresar una Domicilio..."
                      type="text"
                      class="form-control"
                      :class="(enviado && !$v.institucion.domicilio.required) ? 'is-invalid' : ''"
                    />
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.domicilio.required"
                      >Debe ingresar un Domicilio</div>
                    </template>
                  </float-label>
                  <float-label label="Codigo postal:" clase="col-sm-6 col-12">
                    <input
                      id="codigoPostal"
                      v-model="institucion.codigo_postal"
                      placeholder="Ingresar una codigo postal..."
                      type="text"
                      inputmode="numeric"
                      class="form-control"
                      :class="(enviado && !$v.institucion.codigo_postal.required) ? 'is-invalid' : ''"
                    />
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.codigo_postal.required"
                      >Debe ingresar un Codigo Postal</div>
                      <div
                        class="invalid-feedback"
                        v-if="institucion.codigo_postal && !$v.institucion.codigo_postal.numeric"
                      >Sólo se aceptan números</div>
                    </template>
                  </float-label>
                  <float-label label="Email:" clase="col-sm-6 col-12">
                    <input
                      id="email"
                      v-model="institucion.email"
                      placeholder="Ingresar un Email..."
                      type="email"
                      class="form-control"
                      :class="(enviado && !$v.institucion.email.required) ? 'is-invalid' : ''"
                    />
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.email.required"
                      >Debe ingresar un Email valido</div>
                    </template>
                  </float-label>
                  <float-label label="Telefono:" clase="col-sm-6 col-12">
                    <input
                      id="telefono"
                      v-model="institucion.telefono"
                      placeholder="Ingresar un telefono..."
                      type="text"
                      class="form-control"
                      :class="(enviado && !$v.institucion.telefono.required) ? 'is-invalid' : ''"
                    />
                    <template v-slot:validation>
                      <div
                        class="invalid-feedback"
                        v-if="enviado && !$v.institucion.telefono.required"
                      >Debe ingresar un Telefono</div>
                    </template>
                  </float-label>
                  <float-label label="Estado:" clase="col-sm-6 col-12">
                    <select class="form-control" v-model="institucion.estado" id="estado">
                      <option value="Habilitado" selected>Habilitado</option>
                      <option value="Deshabiliado">Deshabiliado</option>
                    </select>
                  </float-label>
                  <div class="col-12">
                    <button class="mt-1 btn btn-info float-right">Guardar</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import Institucion from "@/models/institucion";
import axios from "axios";
import { required, numeric } from "vuelidate/lib/validators";
export default {
  name: "NuevaInstitucion",
  components: {
    TituloComponente,
    FloatLabel,
  },
  validations: {
    institucion: {
      razon_social: { required },
      cuit: { required, numeric },
      provincia: { required },
      localidad: { required },
      domicilio: { required },
      codigo_postal: { required, numeric },
      email: { required },
      telefono: { required },
      estado: { required },
    },
  },
  data() {
    return {
      institucion: new Institucion(
        null,
        "",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        "Habilitado"
      ),
      provincias: null,
      provincia: null,
      provinciaSelected: null,
      municipios: null,
      loading: false,
      enviado: false,
    };
  },
  created() {
    this.obtenerProvincias();
  },
  methods: {
    guardarInstitucion() {
      this.enviado = true;
      this.$v.$touch();
      this.loading = true;
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/institucion", this.institucion)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarInstituciones" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    obtenerProvincias() {
      axios
        .get("https://apis.datos.gob.ar/georef/api/provincias")
        .then((res) => {
          if (res.data.provincias) {
            this.provincias = res.data.provincias;
            this.provincias.sort(function (a, b) {
              if (a.nombre > b.nombre) {
                return 1;
              }
              if (a.nombre < b.nombre) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    obtenerMunicipios() {
      axios
        .get(
          "https://apis.datos.gob.ar/georef/api/municipios?provincia=" +
            this.provinciaSelected.id +
            "&campos=id,nombre&max=100"
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.municipios) {
            this.municipios = res.data.municipios;
            this.municipios.sort(function (a, b) {
              if (a.nombre > b.nombre) {
                return 1;
              }
              if (a.nombre < b.nombre) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
            this.institucion.provincia = this.provinciaSelected.nombre;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>